import React from 'react'
import styles from './styles.module.css'
import Img from '../../../Img' // task #67: canonical image component
import SimpleBlockContent from '../../../SimpleBlockContent'
import { PALETTE } from '../../../../styles/constants'

const cx = (...c) => c.filter(Boolean).join(' ')

function PedalsShowcase({ title, subtitles, sideImage, specsA, specsB, textPostSpecs, reversed }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={cx(styles.textWrapper, reversed && styles.textWrapperReversed)}>
          <div className={styles.title}>
            <SimpleBlockContent blocks={title} noSpace/>
          </div>
          <div className={styles.subtitlesWrapper}>
            {
              subtitles.map((s, i) => <SimpleBlockContent
                key={`subtitle-${i}`}
                blocks={s.text}
                highlight={s.highlight}
                highlightSx={`color: ${PALETTE.white};`}
                highlightExactMatch={true}
                noSpace
              />)
            }
          </div>
          <div className={styles.line}/>
          { renderSpecsList(specsA) }
          <div className={styles.line}/>
          { renderSpecsList(specsB) }
          <div className={styles.textPostSpecs}>
            <SimpleBlockContent blocks={textPostSpecs} noSpace/>
          </div>
        </div>
        <div className={cx(styles.imageWrapper, reversed && styles.imageWrapperReversed)}>
          {/* task #67: descriptor via <Img> */}
          <Img
            image={sideImage}
            alt={title}
            layout="fill"
            objectFit="contain"
          />
        </div>
      </div>
    </div>
  )
}

const renderSpecsList = (specs) => {
  if (!specs) return null

  return (
    <div className={styles.specsWrapper}>
      <div className={styles.specsCol}>
        { specs.slice(0, specs.length / 2).map(spec => renderSingleSpec(spec.title, spec.subtitle, spec.icon))}
      </div>
      <div className={styles.specsCol}>
        { specs.slice(specs.length / 2).map(spec => renderSingleSpec(spec.title, spec.subtitle, spec.icon))}
      </div>
    </div>
  )
}

const renderSingleSpec = (title, subtitle, icon) => {
  return (
    <div className={styles.spec}>
      {/* eslint-disable-next-line local-rules/img-requires-dimensions -- faithful port of the former (empty) styled.img Icon: no reserved box existed pre-migration; sizing is intrinsic/CSS-driven, adding fabricated dimensions would alter layout (#89) */}
      {icon && <img className={styles.icon} src={icon?.src}/>}{/* task #67: styled img src from descriptor */}
      <div className={styles.specTitle}>
        <SimpleBlockContent blocks={title} noSpace/>
      </div>
      <div className={styles.specSubtitle}>
        <SimpleBlockContent blocks={subtitle} noSpace/>
      </div>
    </div>
  )
}

export default PedalsShowcase
